import Business from '../../../images/About-Business.svg';
import './About.scss';

export default function About() {
	return (
		<section className='about my-5' id='about'>
			<div className='container'>
				<div className='row'>
					<div className='col-12 col-md-8'>
						<div className='bg-dark py-5 p-content h-content d-flex flex-column justify-content-center'>
							<div className='d-flex justify-content-end align align-items-baseline about-title'>
								<i className='bi bi-building fs-3 bg-primary-hover pe-2 about-title'></i>
								<h4 className='py-3 fs-3 bg-primary-light about-title'>
									Acerca de Nosotros
								</h4>
							</div>
							<p className='display-5 text-white'>Redefiniendo la logística de entrega</p>
							<p className='text-white t-justify lead'>
								Ekklexia Logistics es la Unidad Logística de Ekklexia Group, grupo
								empresarial 100% Mexicano con sede en la Ciudad de México.
							</p>
							<a type='button' href='/nosotros' className='btn btn-about fs-4'>
								Saber Más
							</a>
						</div>
					</div>
					<div className='col-12 col-md-4 img-about'>
						<div className='d-flex h-img border-2 border-cover-color'>
							<img src={Business} alt='Business' className='img-fluid' />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
